'use strict';

CompanyGuestAlbumsCtrl.$inject = [
  '$scope',
  '$stateParams',
  'publication',
  'UploadTracker',
  'config',
  'growl',
  'translations'
];
function CompanyGuestAlbumsCtrl(
	$scope, 
	$stateParams, 
	publication,
	uploadTracker,
	config,
	growl,
	translations) {
  $scope.publication = publication;

  $scope.uploadFilesForPublication = function(files, publicationId) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
        file: f,
      };
    }));
  };

  $scope.onFileSelect = function($files) {
    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id) {
      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
        publication.versionNumber += files.length;
        $scope.$broadcast("files-uploaded", files);
      });
    } else {
      growl.addErrorMessage(translations['publication.file-upload-locked']);
      return false;
    }
  };
}

CompanyGuestAlbumsCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.file-upload-locked'
    ]);
  }]
};
module.exports = CompanyGuestAlbumsCtrl;

angular.module('dokiv')
  .controller('CompanyGuestAlbumsCtrl', CompanyGuestAlbumsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/albums/CompanyGuestAlbumsCtrl.js
// module id = 283
// module chunks = 0